import { EndLessonAction } from "../../shared/schema/AgentActionSchemas";
import { Streaming } from "../../shared/types/Streaming";
import { AgentActionUtil, registerActionUtil } from "./AgentActionUtil";

export const EndLessonActionUtil = registerActionUtil(
  class EndLessonActionUtil extends AgentActionUtil<EndLessonAction> {
    static override type = "end_lesson" as const;

    override getInfo() {
      return {
        icon: "cross" as const,
        description: "Ending lesson",
      };
    }

    override savesToHistory(): boolean {
      return false;
    }

    override applyAction(action: Streaming<EndLessonAction>) {
      window.dispatchEvent(
        new CustomEvent("notepad-bite:end-lesson", {
          detail: {
            timestamp: (action as Record<string, unknown>).timestamp,
          },
        }),
      );
    }
  },
);
